import { Component, OnInit, AfterViewInit, PLATFORM_ID, Inject, HostListener, ElementRef, Renderer2 } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { WebsiteService } from 'src/app/_services/website.service';
import { ToastrService } from 'ngx-toastr';
import { LinkService } from '../../_services/langhfre.service';
import * as $ from 'jquery';
import { ActivatedRoute, Router } from '@angular/router';
import { LoadScriptService } from 'src/app/_services/load-script.service';
declare function ire(string,{}): any;
@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.scss']
})
export class PricingComponent implements OnInit {
  isYearlyChecked: boolean = true;
  formSection: boolean = true;
  thankSection: boolean = false;
  contactForm: FormGroup;
  disabledSubmitButton: boolean = true;
  contactUsSection: String;
  monthfinalSection: boolean = false;
  YearlyfinalSection: boolean = true;
  country: string;
  encodedData: any;
  decodedData: any;
  paymentModeOption: any;
  finalAmmount: any;

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private route: ActivatedRoute,
    public paymentService: WebsiteService,
    private el: ElementRef, private renderer: Renderer2,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService,
    private router: Router,
    public loadScript: LoadScriptService
  ) {
  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      if (localStorage.getItem("country-trinka") == null || localStorage.getItem("country-trinka") == "") {
        this.loadGeoAPIScript();
      }
    }
    this.titleService.setTitle('Poderoso verificador gramatical e assistente de escrita - Trinka');
    this.metaTagService.updateTag({ name: 'description', content: "Mude para Trinka, uma ferramenta de verificação gramática on-line criada para redação acadêmica e técnica, gratuitamente. Escreva melhor a qualquer hora, em qualquer lugar com a Trinka!" });
    this.metaTagService.updateTag({ property: 'og:title', content: 'Gramática Inglês Profissional ao Melhor Valor!' });
    this.metaTagService.updateTag({ property: 'og:description', content: 'A Trinka é uma verificação gramátical online gratuita que verifica 3000+ erros gramaticais em inglês, aprimoramentos de tom e estilo. Com a Trinka e seus outros recursos premium você torna sua escrita limpa e clara.' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/pt/pricing' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ name: 'language', content: 'pt-pt' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/pt/pricing' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/pricing'});
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/pricing'});
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/pricing' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/pricing' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/pricing' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/pricing' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/pricing' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/pricing' });
    if (isPlatformBrowser(this.platformId)){
      $.getScript('../../../assets/js/wisepop.js', function(){});
    }
    this.country = localStorage.getItem("country-trinka") ? localStorage.getItem("country-trinka") : "en";
      // console.log(this.country);
      this.route.params.subscribe(params => {
        this.encodedData = params['id'];
        this.paymentService.getPlans(this.encodedData,1).subscribe(resp => {
          if (resp['message'] == 'success') {
            this.decodedData = resp['data']
            this.decodedData.sort((a, b) => a.index - b.index);
            this.paymentModeOption = this.decodedData;
            console.log("Country is: ",this.country);
            // console.log(this.decodedData);
            // console.log(this.decodedData[2].final_amount);
            // this.onSelectionPlan(this.paymentModeOption[2], 2)
            var annualAmount = this.decodedData[3].final_amount;
            this.finalAmmount = annualAmount / 12;
            // console.log(this.finalAmmount);
          }
        });
      });
  }

  loadGeoAPIScript() {
    if (isPlatformBrowser(this.platformId)) {
      var scriptName = "geoIP"
      this.loadScript.loadScript(scriptName, '//geoip-js.com/js/apis/geoip2/v2.1/geoip2.js')
        .then(() => {
          console.log(`${scriptName} loaded successfully`);
          var onSuccess = function (location) {
            localStorage.setItem("country-trinka", location['country']['iso_code'])
          };

          var onError = function (error) {
            localStorage.setItem("country-trinka", "IN")
          };
          try {
            //@ts-ignore
            geoip2.city(onSuccess, onError);
          } catch (error) {
            console.log(error)
          }
        })
        .catch(() => {
          console.error(`Failed to load ${scriptName}`);
        });
    }
  }

  
  monthyPricing(){
    this.monthfinalSection = true;
    this.YearlyfinalSection = false;
  }
  yearlyPricing(){
    this.monthfinalSection = false;
    this.YearlyfinalSection = true;
  }
//   scroll(el: HTMLElement) {
//     el.scrollIntoView();
// }
  scroll(el: HTMLElement) {
    el.scrollIntoView({behavior: 'smooth'});
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const element = this.el.nativeElement.querySelector('.table-container');
    const rect = element.getBoundingClientRect();

    if (rect.top <= 0) {
      // Add your CSS class when the element touches the top of the page
      this.renderer.addClass(element, 'sticky-class');
    } else {
      // Remove the CSS class when the element is not touching the top of the page
      this.renderer.removeClass(element, 'sticky-class');
    }
  }
}
